export default {
    path: '/auth',
    component: () => import('../Auth.vue'),
    children: [
        {
            path: 'login',
            name: 'Đăng Nhập',
            component: () => import('../login/Login.vue')
        },
        {
            path: 'forget-password',
            name: 'Quên mật khẩu',
            component: () => import('../forgetPassword/ForgetPassword.vue')
        },
        {
            path: 'reset-password/:token',
            name: 'Tạo lại mật khẩu',
            component: () => import('../resetPassword/ResetPassword.vue')
        },
    ]
};